"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "transformerSteg", {
    enumerable: true,
    get: function() {
        return transformerSteg;
    }
});
var transformerSteg = function(transformerere) {
    var metodeNavn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "transform";
    return function(id, data) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var transformer = transformerere[id];
        if (!transformer[metodeNavn]) {
            return data;
        }
        return transformer[metodeNavn](data, options);
    };
};
